<template>
  <div class="card h-100 px-3 py-2">
    <div v-if="!!block && !!block.text" v-html="block.text"></div>
    <table :class="`table table-responsive-sm table-no-top-border table-sm my-2`">
      <thead>
        <tr>
          <th role="columnheader" style="width: 34%;">{{ trans('team') }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'GP' : 'PJ' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'W' : 'G' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'L' : 'D' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'T' : 'N' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'GF' : 'BP' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'GA' : 'BC' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'GD' : 'BD' }}</th>
          <th role="columnheader" style="width: 8%;">{{ lang == 'en' ? 'Pts' : 'Pts' }}</th>
        </tr>
      </thead>
      <tbody v-if="!!teams">
        <tr v-for="team in teams" :key="team.id">
          <td style="width: 34%;">
            <img v-if="!!team.image_url" :src="team.image_url" style="max-height: 40px;" />
            <span v-if="!team.image_url" class="h3"><i class="fa fa-fw fa-tshirt text-muted"></i></span>
            <span class="d-none d-md-inline">{{ team.name }}</span>
            <small class="d-md-none d-block">{{ team.name }}</small>
          </td>
          <td style="width: 8%;">{{ team.played }}</td>
          <td style="width: 8%;">{{ team.wins }}</td>
          <td style="width: 8%;">{{ team.losses }}</td>
          <td style="width: 8%;">{{ team.ties }}</td>
          <td style="width: 8%;">{{ team.goals }}</td>
          <td style="width: 8%;">{{ team.goals_against }}</td>
          <td style="width: 8%;">{{ team.goals_diff }}</td>
          <td style="width: 8%;">{{ team.points }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="!!block && !!block.text2" v-html="block.text2"></div>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      isPreview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        lang: lang,
        currency: _.currency,
        busy: false,
        error: null,
        teams: null,
      }
    },
    computed: {
    },
    watch: {
      block() {
        this.fetch()
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        if (this.isPreview) {
          let url = `/organization/${this.organization.id}/page/${this.page.id}/simulate_teams_standings`
          axios.post(url, this.block)
          .then(response => {
            this.busy = false
            this.teams = response.data
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        } else {
          let slug = (this.page.slug || '').replace('/', '') || 'undefined'
          let url = `/org/${this.organization.id}/page/${this.page.upid}/${slug}/teams/${this.block.id}/standings`
          axios.get(url)
          .then(response => {
            this.busy = false
            this.teams = response.data
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        }
      },
    },
    mounted() {
      window['pageTeamStandings'+(!!this.block ? this.block.id || '' : '')] = this
      this.fetch()
    },
  }
</script>